export default "__VITE_ASSET__CJamu8un__"